module.exports = __webpack_public_path__ + "img/scene19.131e263c.gif";